import { Component } from '@angular/core'

@Component({
  selector: '[app-modal-body]',
  host: {
    class: 'modal-body',
  },
  template: '<ng-content></ng-content>',
  styles: `
    :host {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 0.25rem;
        max-height: calc(90vh - 150px);
        padding: 0 0.5rem;
    }
  `,
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class ModalBodyComponent {}
